import { WppGrid } from '@wppopen/components-library-react'
import ImageContainer from 'components/imageContainer'
import TextContainer from 'components/TextContainer/TextContainer'
import type { v5 } from '@contracts'
import AsyncContentBlock from 'components/AsyncContentBlock/AsyncContentBlock'

interface ProductDetailProps {
  productData: v5.JobsDetailData | null
  isInitialising?: boolean
}

const ProductDetail = ({ productData, isInitialising }: ProductDetailProps) => {
  const content_items = productData?.content_items || []

  const titleIdx = content_items.findIndex(contentItem => contentItem.type === 'title')
  if (titleIdx >= 0) {
    // move title item to the first index of the content_items array
    const titleItem = content_items.splice(titleIdx, 1)[0]
    content_items.unshift(titleItem)
  }
  const InitialContentItems = content_items.slice(0, 2)
  const RestContentItems = content_items.slice(2)

  return (
    <WppGrid container fullWidth data-testid="pdp-content-data">
      <WppGrid item all={12}>
        <ImageContainer
          imageUrl={productData?.config?.product?.reference_image_url}
          alt={productData?.product_name}
          isInitialising={isInitialising}
        />
      </WppGrid>
      <WppGrid item all={12}>
        <WppGrid fullHeight fullWidth container>
          {isInitialising ? (
            <>
              <AsyncContentBlock all={24} />
              <AsyncContentBlock all={24} />
            </>
          ) : (
            InitialContentItems.map(contentItem => (
              <WppGrid item all={24} key={contentItem._id} fullHeight fullWidth>
                <TextContainer content={contentItem} status={productData?.status} isInitialising={isInitialising} />
              </WppGrid>
            ))
          )}
        </WppGrid>
      </WppGrid>
      {isInitialising ? (
        <AsyncContentBlock all={24} height={250} />
      ) : (
        RestContentItems.map(contentItem => (
          <WppGrid item all={24} key={contentItem._id}>
            <TextContainer content={contentItem} status={productData?.status} isInitialising={isInitialising} />
          </WppGrid>
        ))
      )}
    </WppGrid>
  )
}

export default ProductDetail
